import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ContactContent extends React.Component{

    constructor(){
        super();

        
        this.state = { 
            loading : 1, 
            name:'',
            email:'',
            phone:'',
            message:'',
            errors:{},
            fopen:false,
            success_message:'',
            reg_error:false,
            err_message:"",
            sending:false
        }
        

    }

    handleSubmit = (event) => {
        event.preventDefault();
        const errors = {};
        if (!this.state.name) {
            errors.name = 'Name is required';
          }  
          if (!this.state.email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.state.email)) {
          errors.email = 'Invalid email';
        }
        
        if (!this.state.message) {
            errors.message = 'Message is required';
          } 
        if (Object.keys(errors).length > 0) {
          this.setState({ errors });
        } else {
            this.setState({sending:true});
             
            var data = {  name:this.state.name, 'email' :this.state.email, 'phone' :this.state.phone, 'message':this.state.message  }
            axios.post(api_base_url+"send_contact", data).then(response=>{

                if(response.data.error)
                {
                    this.setState({reg_error:true});
                    this.setState({fopen:false});
                    this.setState({err_message: response.data.message});  
                }
                else{
                    
                    this.setState({fopen:true});
                    this.setState({reg_error:false});
                    this.setState({success_message:" Enquiry Successfully Sent."});
                    this.setState({name:'',email:'', phone:'',message:'', sending:false});
                }
                
            }).catch((error) => { 
                  console.log('Conflict error:', error.response);
               
            });

        }
      };
    
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
      };

   

    render()
    { 
        const locations = JSON.parse(localStorage.getItem("locations"));
        const settings = JSON.parse(localStorage.getItem("settings"));
        
    return (
<div>
     <section className="section-padded">
      <h1
        className="cp-title aos-init aos-animate"
        data-aos="fade-up"
        data-aos-duration="500"
        data-aos-delay="200"
      >
        LOCATIONS
      </h1>

      <div className="contact-page cards">
       {locations.map((item, index) => (  
        <div
          className="card contact-card aos-init aos-animate"
          data-aos="fade-up"
          data-aos-duration="500"
          data-aos-delay="100"
        >
          <div
            className="card-image aos-init aos-animate"
            data-aos="fade-down"
            data-aos-duration="500"
            data-aos-delay="200"
          >
            <img
              src={item.image}
              alt={item.title}
            />
          </div>

          <div className="card-details">
            <h1 className="card-title">{item.location}</h1>
            <p className="contact-name">
              {item.title}
            </p>
            <p className="contact-address">
              {item.address}
            </p>
        {item.toll_free &&
            <p className="contact-numners">
              <strong>TOLL-FREE:</strong>{item.toll_free}
            </p>
        } {item.tel &&
            <p className="contact-numners">
              <strong>TEL:</strong> {item.tel}
            </p>
    }{item.fax &&
            <p className="contact-numners">
              <strong>FAX:</strong> {item.fax}
            </p>

    }{item.map &&

            <Link
              target="_blank"
              rel="noopener noreferrer"
              to={item.map}
              className="card-map"
            ></Link>
    }
          </div>
        </div>
    ))}
      </div>
    </section>

      <section className="section-padded dep-section">
      <h1
        className="cp-title aos-init aos-animate"
        data-aos="fade-up"
        data-aos-duration="500"
        data-aos-delay="400"
      >
        DEPARTMENTS
      </h1>

      <div className="cards">
        {/* Department Cards */}
        {[
          {
            title: "Front Desk",
            detail: "general enquiries",
            email: settings.site_general_enquiries
          },
          {
            title: "Careers",
            detail: "career opportunities",
            email: settings.site_career_opportunities
          },
          {
            title: "Public Relations",
            detail: "media related matters",
            email: settings.site_media_related_matters
          },
          {
            title: "Training",
            detail: "Courses and Overview",
            email: settings.site_courses_and_overview
          }
        ].map((item, index) => (
          <div
            key={index}
            className="card email-card aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration="500"
            data-aos-delay={500 + index * 100}
          >
            <div className="card-details">
              <div className="card-title">{item.title}</div>
              <div className="card-detail">{item.detail}</div>
              <a href={`mailto:${item.email}`} className="email-address">
                {item.email}
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
 </div>
            
    );
}

}

export default ContactContent;